import { Info, OctagonAlert, TriangleAlert } from "lucide-react";
import { useTheme } from "next-themes";
import { Toaster as Sonner, type ToasterProps } from "sonner";
import { CircleCheck } from "@/components/animate-ui/icons/circle-check";
import { Loader } from "@/components/animate-ui/icons/loader";

const Toaster = ({ ...props }: ToasterProps) => {
	const { theme = "system" } = useTheme();

	return (
		<Sonner
			theme={theme as ToasterProps["theme"]}
			className="toaster group"
			closeButton
			icons={{
				success: <CircleCheck className="size-4" animateOnHover />,
				info: <Info className="size-4" />,
				warning: <TriangleAlert className="size-4" />,
				error: <OctagonAlert className="size-4" />,
				loading: <Loader className="size-4" animateOnHover />,
			}}
			style={
				{
					"--normal-bg": "var(--popover)",
					"--normal-text": "var(--popover-foreground)",
					"--normal-border": "var(--border)",
					"--border-radius": "var(--radius)",
				} as React.CSSProperties
			}
			{...props}
		/>
	);
};

export { Toaster };
